export default {
  namespaced: true,
  state: {
    endpoint: "/client/custom/lamcom/hive/projects/",
    key: "jobs",
    permissionKey: ""
  },
  mutations: {},
  actions: {},
  getters: {}
};
